export default {
  drawer: null,
  color: "primary",
  loader: false,
  showChat: false,
  pendingRequests: 0,
  appState: null,
  isLoggedIn: false,
  paymentStep: null,
};
